<template>
  <label class="custom-toggle" :class="switchClass">
    <input type="checkbox" v-model="model" v-on:click.prevent="action">
    <span class="custom-toggle-slider rounded-circle"
          :data-label-off="offText"
          :data-label-on="onText">
    </span>
  </label>
</template>
<script>
  import swal from 'sweetalert2';

  export default {
    name: 'base-switch',
    props: {
      value: [Array, Boolean],
      type: String,
      onText: {
        type: String,
        default: 'Yes'
      },
      offText: {
        type: String,
        default: 'No'
      }
    },
    computed: {
      switchClass() {
        let baseClass = 'custom-toggle-';
        if (this.type) {
          return baseClass + this.type
        }
        return ''
      },
      model: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
      }
    },
    methods: {
      triggerToggle() {
        this.model = !this.model;
      },
      action(e){
        
        e.preventDefault();
        swal({
          title: 'Estas segur@?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Si',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$emit('success');
            this.triggerToggle();
          }else{
            
          }
        });
      }
    },


  };
</script>
<style></style>
